import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { Grid2 } from '@mui/material';
import Image from 'next/image';
import ContractImage from '/public/images/compliant/contract.svg';
import { useTranslations } from 'next-intl';
import Link from 'next/link';

const Contracts = () => {
  const t = useTranslations('Compliant.contracts');
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  return (
    <Grid2 container spacing={4} size={12} display="flex" alignItems="center">
      <Grid2
        size={{
          xs: 12,
          md: 6,
        }}
      >
        <Box>
          <Box marginBottom={2}>
            <Typography
              variant="h4"
              sx={{
                fontWeight: 700,
              }}
            >
              {t('title')}
            </Typography>
          </Box>
          <Box marginBottom={3}>
            <Typography variant="h6" component="p" color="text.secondary">
              {t('description')}
            </Typography>
          </Box>
          <Box
            display="flex"
            flexDirection={{ xs: 'column', sm: 'row' }}
            alignItems={{ xs: 'stretched', sm: 'flex-start' }}
          >
            <Link href={'/book-demo'} legacyBehavior>
              <a rel="noopener noreferrer" target="_blank">
                <Box
                  component={Button}
                  variant="contained"
                  color="primary"
                  size="large"
                  fullWidth={!isMd}
                  marginTop={{ xs: 1, sm: 0 }}
                >
                  {t('action')}
                </Box>
              </a>
            </Link>
          </Box>
        </Box>
      </Grid2>
      <Grid2 size={{ xs: 12, md: 6 }}>
        <Box height={1} width={1} display={'flex'} justifyContent={'center'}>
          <Box height={1} width={1} maxWidth={450}>
            <Image
              src={ContractImage}
              alt="compliant contract image"
              width={450}
              style={{
                maxWidth: '100%',
                maxHeight: '100%',
              }}
            />
          </Box>
        </Box>
      </Grid2>
    </Grid2>
  );
};

export default Contracts;
